import Connector, { takeQuery } from '../../agent';
import types from './types';

const UnNumbers = {
  getUnNumberList: () => Connector.api.get('/unNumbers/autocomplete')
};

const unNumberSagas = [takeQuery(types.GET_UN_NUMBER_LIST, UnNumbers.getUnNumberList)];

export default unNumberSagas;
